"use client";

import { useEffect } from "react";
import { deviceDetector } from "@ospweb/sdk-ui";
import { getBridge } from "@/src/lib/bridge/bridge";
import { MessageType } from "@/src/lib/bridge/types";
import { schedulePaymentBridgeReconcile } from "@/src/lib/bridge/paymentBridgeReconcile";

/**
 * App Shell：WebView 恢复可交互后协调支付会话 reconcile（首期仅支付）。
 */
export function useNativeBridgeReconcile(): void {
  useEffect(() => {
    if (!deviceDetector.isApp()) {
      return;
    }

    const onInteractive = (data?: { reason?: string }) => {
      schedulePaymentBridgeReconcile(
        data?.reason ?? "shell-webview-interactive",
      );
    };

    const onVisibility = () => {
      if (document.visibilityState === "visible") {
        schedulePaymentBridgeReconcile("visibilitychange");
      }
    };

    const onPageShow = () => {
      schedulePaymentBridgeReconcile("pageshow");
    };

    const onForeground = () => {
      schedulePaymentBridgeReconcile("app-foreground");
    };

    const offInteractive = getBridge().on(
      MessageType.SHELL_WEBVIEW_INTERACTIVE,
      onInteractive,
    );
    const offForeground = getBridge().on(
      MessageType.APP_FOREGROUND,
      onForeground,
    );

    document.addEventListener("visibilitychange", onVisibility);
    window.addEventListener("pageshow", onPageShow);
    window.addEventListener("focus", onVisibility);

    return () => {
      offInteractive();
      offForeground();
      document.removeEventListener("visibilitychange", onVisibility);
      window.removeEventListener("pageshow", onPageShow);
      window.removeEventListener("focus", onVisibility);
    };
  }, []);
}
